import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "message-date" }
const _hoisted_3 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  style: {"position":"fixed","right":"-70px","width":"30%","bottom":"1vmin","z-index":"10"}
}
const _hoisted_7 = { class: "message-date" }
const _hoisted_8 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", {
      style: _normalizeStyle(_ctx.boutonStyle)
    }, [
      _createVNode(_component_v_badge, {
        color: "red",
        class: "align-self-center",
        content: _ctx.unreadChatCount,
        "model-value": _ctx.unreadChatCount > 0
      }, {
        badge: _withCtx(() => [
          (_ctx.unreadChatCount !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.unreadChatCount), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reduce())),
            icon: "$fa-comments",
            size: _ctx.$vuetify.display.mobile ? 'small' : undefined,
            elevation: "1"
          }, null, 8, ["size"])
        ]),
        _: 1
      }, 8, ["content", "model-value"])
    ], 4), [
      [_vShow, _ctx.minus]
    ]),
    (_ctx.$vuetify.display.mobile)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.showDialog,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showDialog) = $event)),
          fullscreen: "",
          "hide-overlay": "",
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "mx-auto",
              width: "350px",
              rounded: "0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, {
                  class: "elevation-0",
                  color: "primary",
                  rounded: "0",
                  flat: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.title), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_menu, { location: "start" }, {
                      activator: _withCtx(({ props: menu }) => [
                        _withDirectives(_createVNode(_component_v_icon, _mergeProps({ icon: "$tune" }, menu), null, 16), [
                          [
                            _directive_tooltip,
                            'Filtres',
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.filter = 'all'), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.filter === 'all')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode("$check")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode("Tous les messages")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.filter = 'waitingResponse'), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.filter === 'waitingResponse')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("$check")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("Message en attente de réponse")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.filter = 'messageSent'), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.filter === 'messageSent')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode("$check")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("Message envoyé")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.filter = 'messageClosed'), ["stop"]))
                            }, {
                              append: _withCtx(() => [
                                (_ctx.filter === 'messageClosed')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createTextVNode("$check")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode("Message fermé")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reduce())),
                      style: {"margin":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { style: {"color":"#fff"} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showDialog ? "$fa-chevron-down" : "$fa-chevron-up"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_layout, { style: {"overflow-y":"auto"} }, {
                  default: _withCtx(() => [
                    (_ctx.filteredChats && _ctx.filteredChats.length)
                      ? (_openBlock(), _createBlock(_component_v_list, {
                          key: 0,
                          width: "100%",
                          density: "compact",
                          lines: "three"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChats, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: item.id,
                                "data-item-id": item.id,
                                onClick: ($event: any) => (_ctx.openChat(item)),
                                class: "oss-list-item mx-2 mb-2",
                                density: "compact",
                                onMouseenter: ($event: any) => (_ctx.hoveredItem = item.id),
                                onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hoveredItem = null))
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: 
                                        !_ctx.currentUser ||
                                        !item.lastMessage?.sender?.id ||
                                        item.lastMessage.sender.id !== _ctx.currentUser.id
                                            ? 'primary'
                                            : 'secondary'
                                    ,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getUserBigram(item.lastMessage.sender)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"])
                                ]),
                                append: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getDate(item.lastMessage.createdAt)), 1),
                                  (_ctx.isInAccountingFirm)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          size: "small",
                                          class: _normalizeClass(["menu-button", { 'menu-open': _ctx.menuOpen === item.id }]),
                                          onClick: _withModifiers(($event: any) => (_ctx.toggleMenu(item.id)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.menuOpen === item.id)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                    _createTextVNode("$fa-chevron-right")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 1,
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                    _createTextVNode("$fa-ellipsis-v")
                                                  ])),
                                                  _: 1
                                                }))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "class"]),
                                        (_ctx.hoveredItem === item.id || _ctx.menuOpen === item.id)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["menu-actions", { 'menu-actions--open': _ctx.menuOpen === item.id }]),
                                              style: _normalizeStyle({ height: _ctx.getItemHeight(item.id) + 'px' })
                                            }, [
                                              _createElementVNode("div", {
                                                class: "menu-item",
                                                onClick: _withModifiers(($event: any) => (_ctx.markChatAsProcessed(item.id)), ["stop"])
                                              }, [
                                                _createVNode(_component_v_icon, {
                                                  size: "x-small",
                                                  class: "mr-1"
                                                }, {
                                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                    _createTextVNode("$fa-check")
                                                  ])),
                                                  _: 1
                                                }),
                                                _cache[31] || (_cache[31] = _createElementVNode("span", null, "Traité", -1))
                                              ], 8, _hoisted_4),
                                              _createElementVNode("div", {
                                                class: "menu-item",
                                                onClick: _withModifiers(($event: any) => (_ctx.relaunchChat(item)), ["stop"])
                                              }, [
                                                _createVNode(_component_v_icon, {
                                                  size: "x-small",
                                                  class: "mr-1"
                                                }, {
                                                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                    _createTextVNode("$fa-retweet")
                                                  ])),
                                                  _: 1
                                                }),
                                                _cache[33] || (_cache[33] = _createElementVNode("span", null, "Relancer", -1))
                                              ], 8, _hoisted_5)
                                            ], 6))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, {
                                    textContent: _toDisplayString(_ctx.getUserDisplayName(item.lastMessage.sender))
                                  }, null, 8, ["textContent"]),
                                  _createVNode(_component_v_list_item_subtitle, {
                                    textContent: _toDisplayString(item.lastMessage.text)
                                  }, null, 8, ["textContent"]),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        dense: "",
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTypeIcon(item)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createTextVNode(_toDisplayString(_ctx.getType(item)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.processed)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        icon: "$check",
                                        size: "small",
                                        class: "oss-list-item__icon"
                                      }, null, 512)), [
                                        [
                                          _directive_tooltip,
                                          'Conversation traitée',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["data-item-id", "onClick", "onMouseenter"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "oss-list-item pl-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                                    _createTextVNode(" Pas de message ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_card, {
            class: "mx-auto",
            elevation: "1",
            width: "350px",
            rounded: "lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                class: "elevation-0",
                color: "primary",
                rounded: "0",
                flat: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_menu, { location: "start" }, {
                    activator: _withCtx(({ props: menu }) => [
                      _withDirectives(_createVNode(_component_v_btn_icon, _mergeProps({ icon: "$tune" }, menu), null, 16), [
                        [
                          _directive_tooltip,
                          'Filtres',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { dense: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter = 'all')),
                            dense: ""
                          }, {
                            append: _withCtx(() => [
                              (_ctx.filter === 'all')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                                      _createTextVNode("$check")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[36] || (_cache[36] = [
                                  _createTextVNode("Tous les messages")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter = 'waitingResponse')),
                            dense: ""
                          }, {
                            append: _withCtx(() => [
                              (_ctx.filter === 'waitingResponse')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                      _createTextVNode("$check")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[38] || (_cache[38] = [
                                  _createTextVNode("Message en attente de réponse")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter = 'messageSent')),
                            dense: ""
                          }, {
                            append: _withCtx(() => [
                              (_ctx.filter === 'messageSent')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createTextVNode("$check")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                  _createTextVNode("Message envoyé")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter = 'messageClosed')),
                            dense: ""
                          }, {
                            append: _withCtx(() => [
                              (_ctx.filter === 'messageClosed')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createTextVNode("$check")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[42] || (_cache[42] = [
                                  _createTextVNode("Message fermé")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reduce())),
                    style: {"margin":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { style: {"color":"#fff"} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.showDialog ? "$fa-chevron-down" : "$fa-chevron-up"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_layout, { style: {"height":"300px","overflow-y":"auto"} }, {
                default: _withCtx(() => [
                  (_ctx.filteredChats && _ctx.filteredChats.length)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 0,
                        width: "100%",
                        density: "compact",
                        lines: "three"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChats, (item) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: item.id,
                              "data-item-id": item.id,
                              onClick: ($event: any) => (_ctx.openChat(item)),
                              class: "oss-list-item mx-2 mb-2",
                              id: 'chat-' + item.id,
                              density: "compact",
                              onMouseenter: ($event: any) => (_ctx.hoveredItem = item.id),
                              onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hoveredItem = null))
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, {
                                  color: 
                                        item.lastMessage?.sender?.id !== _ctx.currentUser?.id
                                            ? 'primary'
                                            : 'secondary'
                                    ,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getUserBigram(item.lastMessage.sender)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              append: _withCtx(() => [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getDate(item.lastMessage.createdAt)), 1),
                                (_ctx.isInAccountingFirm)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      (_ctx.hoveredItem === item.id || _ctx.menuOpen === item.id)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            icon: "",
                                            size: "small",
                                            class: _normalizeClass(["menu-button", { 'menu-open': _ctx.menuOpen === item.id }]),
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleMenu(item.id)), ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.menuOpen === item.id)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                      _createTextVNode("$fa-chevron-right")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 1,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                      _createTextVNode("$fa-ellipsis-v")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick", "class"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.hoveredItem === item.id || _ctx.menuOpen === item.id)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["menu-actions", { 'menu-actions--open': _ctx.menuOpen === item.id }]),
                                            style: _normalizeStyle({ height: _ctx.getItemHeight(item.id) + 'px' })
                                          }, [
                                            _createElementVNode("div", {
                                              class: "menu-item",
                                              onClick: _withModifiers(($event: any) => (_ctx.markChatAsProcessed(item.id)), ["stop"])
                                            }, [
                                              _createVNode(_component_v_icon, {
                                                size: "x-small",
                                                class: "mr-1"
                                              }, {
                                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                  _createTextVNode("$fa-check")
                                                ])),
                                                _: 1
                                              }),
                                              _cache[46] || (_cache[46] = _createElementVNode("span", null, "Traité", -1))
                                            ], 8, _hoisted_9),
                                            _createElementVNode("div", {
                                              class: "menu-item",
                                              onClick: _withModifiers(($event: any) => (_ctx.relaunchChat(item)), ["stop"])
                                            }, [
                                              _createVNode(_component_v_icon, {
                                                size: "x-small",
                                                class: "mr-1"
                                              }, {
                                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                  _createTextVNode("$fa-retweet")
                                                ])),
                                                _: 1
                                              }),
                                              _cache[48] || (_cache[48] = _createElementVNode("span", null, "Relancer", -1))
                                            ], 8, _hoisted_10)
                                          ], 6))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  textContent: _toDisplayString(_ctx.getUserDisplayName(item.lastMessage.sender))
                                }, null, 8, ["textContent"]),
                                _createVNode(_component_v_list_item_subtitle, {
                                  textContent: _toDisplayString(item.lastMessage.text)
                                }, null, 8, ["textContent"]),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "mr-2",
                                      size: "x-small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getTypeIcon(item)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getType(item)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (item.processed)
                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      icon: "$check",
                                      size: "small",
                                      class: "oss-list-item__icon"
                                    }, null, 512)), [
                                      [
                                        _directive_tooltip,
                                        'Conversation traitée',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["data-item-id", "onClick", "id", "onMouseenter"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, { class: "oss-list-item pl-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                  _createTextVNode(" Pas de message ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 512)), [
          [_vShow, !_ctx.minus]
        ]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.showNotificationDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showNotificationDialog) = $event)),
      title: 
                _ctx.$t('chat.notification.waitingResponse', _ctx.unreadChatCount, {
                    count: _ctx.unreadChatCount,
                })
            ,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              class: _normalizeClass(
                        !_ctx.$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    ),
              onClick: _cache[14] || (_cache[14] = ($event: any) => {
                        _ctx.showNotificationDialog = false;
                        _ctx.filter = 'waitingResponse';
                        _ctx.minus = false;
                    })
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_btn_next)
              ]),
              default: _withCtx(() => [
                (!_ctx.$vuetify.display.mobile)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      color: "primary"
                    }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createTextVNode(" $fa-comments")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("chat.notification.showWaitingResponse", _ctx.unreadChatCount)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]),
            (_ctx.chatWithDocuments.length)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  class: _normalizeClass(
                        !_ctx.$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    ),
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showDocuments()), ["stop"]))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_next)
                  ]),
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[51] || (_cache[51] = [
                            _createTextVNode("$fa-file-pdf")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                            "chat.notification.showWaitingResponseDocuments",
                            _ctx.chatWithDocuments.length,
                            { count: _ctx.chatWithDocuments.length },
                        )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (_ctx.chatWithExpenseReports.length)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  class: _normalizeClass(
                        !_ctx.$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    ),
                  onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.showExpenseReports()), ["stop"]))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_next)
                  ]),
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createTextVNode("$fa-receipt")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                            "chat.notification.showWaitingResponseExpenseReports",
                            _ctx.chatWithExpenseReports.length,
                            { count: _ctx.chatWithExpenseReports.length },
                        )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (_ctx.chatWithBankTransactions.length)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 2,
                  class: _normalizeClass(
                        !_ctx.$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    ),
                  onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.showBankTransactions()), ["stop"]))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_next)
                  ]),
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "primary"
                        }, {
                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                            _createTextVNode("$fa-university")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                            "chat.notification.showWaitingResponseBankTransactions",
                            _ctx.chatWithBankTransactions.length,
                            { count: _ctx.chatWithBankTransactions.length },
                        )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar.show,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.snackbar.show) = $event)),
      color: _ctx.snackbar.color,
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbar.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}